module.exports = __webpack_public_path__ + "static/media/DNI.fcea2112.svg";